(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-libase-fast-collection]';
  const pending = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const count = Number(entry.target.dataset.libaseImageCount) || 4;
      Array.from(entry.target.querySelectorAll('.card__media .media > img:first-child')).slice(0, count).forEach((image) => {
        image.loading = 'eager';
      });
      observer.unobserve(entry.target);
    });
  }, {rootMargin: '700px 0px'}) : null;
  function initialize(scope) {
    if (!observer) return;
    scope.querySelectorAll(selector).forEach((collection) => {
      if (pending.has(collection)) return;
      pending.add(collection);
      observer.observe(collection);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), {once: true});
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((collection) => {
      observer?.unobserve(collection);
      pending.delete(collection);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-lp"] && !Shopify.designMode) return;
  try {
    
if (!window.libaseIgClickListener) {
  window.libaseIgClickListener = true;
  document.addEventListener('click', function (event) {
    const target = event.target.closest && event.target.closest('[data-libase-ig] a[data-lig-click]');
    if (!target) return;
    const detail = { event: 'libase_lp_click', lp_name: 'instagram', placement: target.dataset.ligClick, product_handle: target.dataset.productHandle || '' };
    document.dispatchEvent(new CustomEvent('libase:lp-click', { detail: detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["libase-gift-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('libase-gift-finder')) {
  customElements.define('libase-gift-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.state = {audience: '', budget: 0, category: 'all'};
      this.strings = JSON.parse(this.querySelector('[data-gift-strings]').textContent);
      this.candidates = Array.from(this.querySelectorAll('template[data-gift-candidate]'));
      this.cardCache = new WeakMap();
      this.preloadCache = new Map();
      this.renderedMatches = [];
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        const nextState = this.stateForButton(button);
        if (!nextState) return;
        this.state = nextState;
        this.render();
      });
      ['pointerover', 'pointerdown', 'focusin'].forEach((type) => {
        this.addEventListener(type, (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          const nextState = this.stateForButton(button);
          if (nextState?.audience) this.warmImages(this.matchesFor(nextState));
        }, {passive: true});
      });
      if (this.dataset.currency && this.dataset.currency !== 'JPY') {
        this.querySelectorAll('[data-gift-budget]:not([data-gift-budget="0"])').forEach((button) => {button.hidden = true;});
      }
    }
    stateForButton(button) {
      if (button.hasAttribute('data-gift-audience')) {
        return {audience: button.dataset.giftAudience, budget: 0, category: 'all'};
      }
      if (button.hasAttribute('data-gift-budget')) return {...this.state, budget: Number(button.dataset.giftBudget)};
      if (button.hasAttribute('data-gift-category')) return {...this.state, category: button.dataset.giftCategory};
      if (button.hasAttribute('data-gift-reset')) return {...this.state, budget: 0, category: 'all'};
      return null;
    }
    matchesFor(state) {
      const seen = new Set();
      const matches = [];
      for (const item of this.candidates) {
        if (item.dataset.audience !== state.audience || (state.budget && Number(item.dataset.price) > state.budget)) continue;
        if (state.category !== 'all' && !item.dataset.category.split(/\s+/).includes(state.category)) continue;
        if (seen.has(item.dataset.productId)) continue;
        seen.add(item.dataset.productId);
        matches.push(item);
        if (matches.length === 3) break;
      }
      return matches;
    }
    warmImages(matches) {
      const connection = navigator.connection;
      if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
      matches.forEach((item) => {
        const source = item.content.querySelector('img');
        if (!source) return;
        const key = [source.getAttribute('src'), source.getAttribute('srcset'), source.getAttribute('sizes')].join('|');
        if (this.preloadCache.has(key)) return;
        const image = new Image();
        image.decoding = 'async';
        image.fetchPriority = 'low';
        if (source.hasAttribute('sizes')) image.sizes = source.getAttribute('sizes');
        if (source.hasAttribute('srcset')) image.srcset = source.getAttribute('srcset');
        image.src = source.getAttribute('src');
        this.preloadCache.set(key, image);
      });
    }
    cardFor(item) {
      if (!this.cardCache.has(item)) {
        const card = item.content.cloneNode(true).firstElementChild;
        card.querySelectorAll('img').forEach((image) => { image.loading = 'eager'; });
        this.cardCache.set(item, card);
      }
      return this.cardCache.get(item);
    }
    render() {
      const s = this.state;
      this.querySelectorAll('[data-gift-audience]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.giftAudience === s.audience)));
      this.querySelectorAll('[data-gift-budget]').forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.giftBudget) === s.budget)));
      this.querySelectorAll('[data-gift-category]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.giftCategory === s.category)));
      this.querySelector('[data-gift-choose]').hidden = true;
      this.querySelector('[data-gift-filters]').hidden = false;
      this.querySelector('[data-gift-results]').hidden = false;
      const matches = this.matchesFor(s);
      const grid = this.querySelector('[data-gift-cards]');
      if (matches.length !== this.renderedMatches.length || matches.some((item, index) => item !== this.renderedMatches[index])) {
        grid.replaceChildren(...matches.map((item) => this.cardFor(item)));
        this.renderedMatches = matches;
      }
      const count = matches.length;
      this.querySelector('[data-gift-count]').textContent = this.strings.count.replace('{count}', count);
      const empty = this.querySelector('[data-gift-empty]');
      empty.hidden = count === 3;
      empty.textContent = count ? this.strings.limited.replace('{count}', count) : this.strings.empty;
      const audience = this.querySelector('[data-gift-audience][aria-pressed="true"]');
      const labels = [audience.dataset.label];
      if (s.budget) labels.push(this.querySelector('[data-gift-budget][aria-pressed="true"]').textContent.trim());
      if (s.category !== 'all') labels.push(this.querySelector('[data-gift-category][aria-pressed="true"]').textContent.trim());
      this.querySelector('[data-gift-summary]').textContent = labels.join(' ／ ');
      this.querySelector('[data-gift-price-note]').textContent = audience.dataset.audienceKind === 'pair' ? this.strings.pair : this.strings.single;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["libase-pair-set-feature"] && !Shopify.designMode) return;
  try {
    
  function libasePairVideoMotion(root) {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.lpsf__video').forEach((video) => {
      video.autoplay = false;
      video.pause();
    });
  }
  libasePairVideoMotion(document);
  document.addEventListener('shopify:section:load', (event) => libasePairVideoMotion(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["libase-swipe-lp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('libase-swipe-lp')) {
    customElements.define('libase-swipe-lp', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.preview = this.dataset.preview === 'true';
        this.links = Array.from(this.querySelectorAll('[data-purchase]'));
        this.links.forEach(link => { link.dataset.destination = link.getAttribute('href'); });
        this.index = 0;
        this.videos = Array.from(this.querySelectorAll('video'));
        this.videos.forEach(video => {
          video.muted = true; video.defaultMuted = true; video.playsInline = true;
          if (!video.closest('.llp-slide--portrait')) return;
          const controls = video.closest('.llp-media').querySelector('[data-video-controls]');
          const playButton = controls.querySelector('[data-video-play]');
          const muteButton = controls.querySelector('[data-video-mute]');
          const startButton = video.closest('.llp-media').querySelector('[data-video-start]');
          controls.hidden = false; video.controls = false;
          const update = () => {
            playButton.textContent = video.paused ? this.labels.play : this.labels.pause;
            if (startButton) startButton.hidden = !video.paused;
            muteButton.textContent = video.muted ? this.labels.unmute : this.labels.mute;
            muteButton.setAttribute('aria-pressed', String(!video.muted));
          };
          startButton?.addEventListener('click', () => video.play().catch(() => {}), { signal: this.signal });
          playButton.addEventListener('click', () => { if (video.paused) video.play().catch(() => {}); else video.pause(); }, { signal: this.signal });
          muteButton.addEventListener('click', () => { video.muted = !video.muted; }, { signal: this.signal });
          ['play','pause','volumechange','ended'].forEach(name => video.addEventListener(name, update, { signal: this.signal }));
          update();
        });
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.motion.addEventListener('change', () => { this.videos.forEach(video => video.pause()); this.syncVideos(); }, { signal: this.signal });
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1), { signal: this.signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), { signal: this.signal });
        this.querySelectorAll('[data-dot]').forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.dot)), { signal: this.signal }));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync(Math.round(this.track.scrollLeft / this.track.clientWidth)));
        }, { passive: true, signal: this.signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
          if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); this.go(event.key === 'Home' ? 0 : this.slides.length - 1); }
        }, { signal: this.signal });
        this.resize = new ResizeObserver(() => this.go(this.index, false));
        this.resize.observe(this.track);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index, false);
        }, { signal: this.signal });
        this.links.forEach(link => link.addEventListener('click', event => {
          if (this.preview) { event.preventDefault(); return; }
          this.tick();
          if (!this.offer && this.promise) {
            event.preventDefault();
            this.status(this.labels.waiting);
            this.promise.finally(() => { if (!this.signal.aborted) window.location.assign(link.href); });
          }
        }, { signal: this.signal }));
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.tick(); this.syncVideos(); }, { signal: this.signal });
        document.addEventListener('libase:lp-state', event => {
          if (this.preview) return;
          if (event.detail) this.activate(event.detail);
          else if (this.offer) this.deactivate(this.labels.unavailable);
        }, { signal: this.signal });
        this.sync(0);
        if (this.preview) {
          const now = Date.now();
          this.activate({ code: 'PREVIEW', expiresAt: new Date(now + 86400000).toISOString(), serverNow: new Date(now).toISOString() });
        } else if (this.dataset.enabled === 'true' && this.dataset.endpoint && this.dataset.currency === 'JPY') {
          this.promise = this.requestOffer().catch(() => this.status(this.labels.unavailable)).finally(() => { this.promise = null; });
        }
      }
      disconnectedCallback() {
        this.videos?.forEach(video => video.pause()); this.controller?.abort(); this.resize?.disconnect(); clearInterval(this.interval); cancelAnimationFrame(this.frame); this.controller = null;
      }
      go(index, smooth = true) {
        index = Math.max(0, Math.min(this.slides.length - 1, index));
        const motion = smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: motion ? 'smooth' : 'instant' });
        if (!motion) this.sync(index);
      }
      sync(index) {
        if (!this.slides.length) return;
        const previousIndex = this.index;
        this.index = Math.max(0, Math.min(this.slides.length - 1, index));
        this.classList.toggle('llp--review-active', this.slides[this.index].classList.contains('llp-slide--live-review'));
        const editorBadge = this.querySelector('.llp-editor-badge');
        if (editorBadge) editorBadge.hidden = this.index !== 0;
        this.slides.forEach((slide, n) => { slide.inert = n !== this.index; });
        this.querySelectorAll('[data-dot]').forEach((dot, n) => { if (n === this.index) dot.setAttribute('aria-current','step'); else dot.removeAttribute('aria-current'); });
        this.querySelector('[data-prev]').disabled = this.index === 0;
        this.querySelector('[data-next]').disabled = this.index === this.slides.length - 1;
        this.querySelector('[data-count]').textContent = `${String(this.index + 1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
        this.querySelector('[data-announcement]').textContent = `${this.index + 1} / ${this.slides.length} ${this.slides[this.index].querySelector('.llp-heading').textContent}`;
        if (!this.videoInitialized || previousIndex !== this.index) { this.videoInitialized = true; this.syncVideos(); }
      }
      syncVideos() {
        this.videos.forEach(video => {
          const visible = video.closest('[data-slide]') === this.slides[this.index] && !document.hidden;
          if (!visible) { video.pause(); return; }
          if (video.preload === 'none') video.preload = 'metadata';
          if (video.closest('[data-video-autoplay]').dataset.videoAutoplay === 'true' && !this.motion.matches) {
            video.muted = true;
            const play = video.play();
            if (play) play.catch(() => {});
          }
        });
      }
      status(message) {
        const el = this.querySelector('[data-status]'); el.textContent = message || ''; el.hidden = !message;
      }
      async requestOffer() {
        if (this.links.some(link => new URL(link.dataset.destination, location.origin).origin !== location.origin)) throw new Error('Store destination required');
        const endpoint = new URL(this.dataset.endpoint.replace(/\/$/, '') + '/offer', location.origin);
        if (endpoint.protocol !== 'https:' && endpoint.hostname !== 'localhost' && endpoint.hostname !== '127.0.0.1') throw new Error('HTTPS required');
        const key = `libase-lp-visitor:${this.dataset.campaign}`;
        let visitorId;
        try {
          visitorId = localStorage.getItem(key);
          if (!/^[a-f0-9]{48}$/.test(visitorId || '')) {
            visitorId = Array.from(crypto.getRandomValues(new Uint8Array(24)), n => n.toString(16).padStart(2,'0')).join('');
            localStorage.setItem(key, visitorId);
          }
        } catch { throw new Error('Storage unavailable'); }
        const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', cache: 'no-store', body: JSON.stringify({ visitorId, campaign: this.dataset.campaign }), signal: AbortSignal.any([this.signal, AbortSignal.timeout(18000)]) });
        if (!response.ok) throw new Error('Offer unavailable');
        const offer = await response.json();
        if (this.signal.aborted) return;
        if (offer.status === 'expired' || offer.status === 'used') { this.status(this.labels.expired); return; }
        if (offer.status !== 'active' || offer.percentage !== 10 || offer.scope !== 'all' || offer.campaign !== this.dataset.campaign || !/^LP[A-Z0-9]{16,40}$/.test(offer.code) || !Number.isFinite(Date.parse(offer.expiresAt)) || !Number.isFinite(Date.parse(offer.serverNow))) throw new Error('Invalid offer');
        if (!/^[a-f0-9]{64}\.[a-f0-9]{64}$/.test(offer.visitorToken || '')) throw new Error('Invalid visitor token');
        localStorage.setItem(`libase-lp-benefit:${this.dataset.campaign}`, JSON.stringify({ visitorToken: offer.visitorToken }));
        await customElements.whenDefined('libase-lp-benefit');
        this.activate(offer);
        document.dispatchEvent(new CustomEvent('libase:lp-issued', { detail: offer }));
      }
      activate(offer) {
        this.offer = offer;
        this.deadline = Date.parse(offer.expiresAt);
        this.serverBase = Date.parse(offer.serverNow);
        this.performanceBase = performance.now();
        this.wallBase = Date.now();
        this.querySelectorAll('[data-offer],[data-discount-price]').forEach(el => { el.hidden = false; });
        this.querySelector('[data-normal-note]').hidden = true;
        this.querySelector('[data-cta-label]').textContent = this.labels.offerCta;
        this.classList.add('is-offer-active');
        this.status('');
        this.links.forEach(link => {
          if (this.preview) return;
          const destination = new URL(link.dataset.destination, location.origin);
          const params = new URLSearchParams(location.search);
          for (const [key, value] of params) if (/^(utm_(source|medium|campaign|content|term|id)|fbclid|preview_theme_id)$/.test(key)) destination.searchParams.set(key,value);
          if (destination.origin !== location.origin) return;
          const root = this.dataset.rootUrl.replace(/\/$/,'');
          link.href = `${root}/discount/${encodeURIComponent(offer.code)}?redirect=${encodeURIComponent(destination.pathname + destination.search + destination.hash)}`;
        });
        const endDisplay = new Date(this.deadline);
        const endTime = new Intl.DateTimeFormat('ja-JP',{timeZone:'Asia/Tokyo',month:'numeric',day:'numeric',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).format(endDisplay);
        this.querySelector('[data-deadline]').textContent = `${endTime}${this.labels.deadline}`;
        this.querySelector('[data-timer-label]').textContent = `${endTime}${this.labels.until}`;
        this.tick();
        clearInterval(this.interval);
        this.interval = setInterval(() => this.tick(),1000);
      }
      deactivate(message) {
        this.querySelectorAll('[data-offer],[data-discount-price]').forEach(el => { el.hidden = true; });
        this.querySelector('[data-normal-note]').hidden = false;
        this.querySelector('[data-cta-label]').textContent = this.labels.cta;
        this.classList.remove('is-offer-active');
        this.links.forEach(link => { link.href = link.dataset.destination; });
        this.offer = null; clearInterval(this.interval); this.status(message);
      }
      tick() {
        if (!this.offer) return;
        const elapsed = Math.max(performance.now() - this.performanceBase, Date.now() - this.wallBase);
        const seconds = Math.max(0, Math.ceil((this.deadline - this.serverBase - elapsed) / 1000));
        if (seconds <= 0) {
          this.deactivate(this.labels.expired); return;
        }
        this.querySelectorAll('[data-timer]').forEach(el => { el.textContent = [Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(n => String(n).padStart(2,'0')).join(':'); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranking-tabs"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeRanking(root) {
    if (root._libaseRankingCleanup) return;
    const listeners = new AbortController();
    const options = {signal: listeners.signal};
    const tabs = Array.from(root.querySelectorAll('.rt-tab'));
    const panels = Array.from(root.querySelectorAll('.rt-panel'));
    let nearViewport = !('IntersectionObserver' in window);
    let observer;

    panels.forEach((panel) => {
      const track = panel.querySelector('.rt-track');
      const viewport = panel.querySelector('.rt-viewport');
      const prevBtn = panel.querySelector('.rt-prev');
      const nextBtn = panel.querySelector('.rt-next');
      if (!track || !viewport || !prevBtn || !nextBtn) return;
      const cards = Array.from(track.querySelectorAll('.rt-card'));
      const perView = 3;
      let page = 0;
      const lastPage = Math.max(0, Math.ceil(cards.length / perView) - 1);

      function warm(to = page) {
        const targetPage = Math.min(Math.max(0, to), lastPage);
        cards.slice(targetPage * perView, (targetPage + 1) * perView).forEach((card) => {
          const image = card.querySelector('img.rt-img');
          if (image) image.loading = 'eager';
        });
      }
      function updateButtons() {
        prevBtn.hidden = nextBtn.hidden = cards.length <= perView;
        prevBtn.disabled = page <= 0;
        nextBtn.disabled = page >= lastPage;
      }
      function go(to) {
        page = Math.min(Math.max(0, to), lastPage);
        if (nearViewport && panel.classList.contains('active')) warm();
        track.style.transform = `translateX(${page * -100}%)`;
        updateButtons();
      }
      prevBtn.addEventListener('click', () => { warm(page - 1); go(page - 1); }, options);
      nextBtn.addEventListener('click', () => { warm(page + 1); go(page + 1); }, options);
      ['pointerenter', 'pointerdown', 'focus'].forEach((type) => {
        prevBtn.addEventListener(type, () => warm(page - 1), options);
        nextBtn.addEventListener(type, () => warm(page + 1), options);
      });
      let startX = 0;
      let deltaX = 0;
      viewport.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
        deltaX = 0;
      }, {passive: true, signal: listeners.signal});
      viewport.addEventListener('touchmove', (event) => {
        deltaX = event.touches[0].clientX - startX;
        if (Math.abs(deltaX) > 20) warm(page + (deltaX < 0 ? 1 : -1));
      }, {passive: true, signal: listeners.signal});
      viewport.addEventListener('touchend', () => {
        if (Math.abs(deltaX) > 50) go(page + (deltaX < 0 ? 1 : -1));
      }, options);
      panel._sliderApi = {update: () => go(page), warm};
      go(0);
    });

    tabs.forEach((tab) => {
      const getPanel = () => panels.find((panel) => panel.dataset.tab === tab.dataset.tab);
      const warm = () => getPanel()?._sliderApi?.warm();
      ['pointerenter', 'pointerdown', 'focus'].forEach((type) => tab.addEventListener(type, warm, options));
      tab.addEventListener('click', () => {
        const target = getPanel();
        if (!target) return;
        tabs.forEach((item) => item.classList.toggle('active', item === tab));
        panels.forEach((item) => item.classList.toggle('active', item === target));
        target._sliderApi?.warm();
        target._sliderApi?.update();
      }, options);
    });

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        nearViewport = true;
        panels.find((panel) => panel.classList.contains('active'))?._sliderApi?.warm();
        observer.disconnect();
      }, {rootMargin: '700px 0px'});
      observer.observe(root);
    }
    root._libaseRankingCleanup = () => {
      listeners.abort();
      observer?.disconnect();
      panels.forEach((panel) => { delete panel._sliderApi; });
      delete root._libaseRankingCleanup;
    };
  }
  function initialize(scope) {
    if (scope.matches?.('.ranking-tabs')) initializeRanking(scope);
    scope.querySelectorAll('.ranking-tabs').forEach(initializeRanking);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), {once: true});
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.ranking-tabs').forEach((root) => root._libaseRankingCleanup?.());
  });
})();

  } catch(e) { console.error(e); }
})();
})();
